import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.math.sign.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

/*
  This module implements shared 'Drilldown Questions' features across drilldown questions.
*/
import { store } from '@/store';
import { FIB } from '@/config/constants';
var QUESTION_TYPE = FIB.QUESTION_TYPE,
    INDICATOR_KIND = FIB.INDICATOR_KIND;
/**
 * Determines if a DD/DD+ question should be added to the selection purely based on counts.
 */

export var selectBasedOnCounts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var question, survey, selection, drilldownTypes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // This probably looks odd - but it is intended that DD & DD+ questions share a joint pool of configuration.
            question = context.question, survey = context.survey, selection = context.selection;
            drilldownTypes = [QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN, QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN_PLUS]; // Respect maxima:

            if (!(selection.countByType(drilldownTypes) >= survey.drilldown.maximum)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            if (!(selection.countByTypeAndTopLevelRating(drilldownTypes, question.topLevelRating) >= survey.drilldown.maximumPerIndicator)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", false);

          case 6:
            return _context.abrupt("return", true);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function selectBasedOnCounts(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Determines if a DD/DD+ question should be added to the selection, ignoring counts.
 */

export var select = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
    var _INDICATOR_KIND$NPS$I, _INDICATOR_KIND$NPS$I2;

    var question, indicator, score, prefix, threshold, direction;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            question = context.question; // Get the indicator and guest's score that the question is predicated on

            indicator = store.getters['answers/getIndicatorById'](question.topLevelRating);
            score = store.getters['answers/getIndicatorScoreById'](question.topLevelRating); // If either of these are empty, we're done

            if (!(!indicator || score === null)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", false);

          case 5:
            if (!(indicator.kind == INDICATOR_KIND.SURVEY_RATING)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", question.numberStars.includes(score));

          case 7:
            // Derived (non-headline) indicators use a threshold score and a direction
            prefix = (_INDICATOR_KIND$NPS$I = (_INDICATOR_KIND$NPS$I2 = {}, _defineProperty(_INDICATOR_KIND$NPS$I2, INDICATOR_KIND.NPS, 'nps'), _defineProperty(_INDICATOR_KIND$NPS$I2, INDICATOR_KIND.CSAT, 'csat'), _INDICATOR_KIND$NPS$I2)[indicator.kind]) !== null && _INDICATOR_KIND$NPS$I !== void 0 ? _INDICATOR_KIND$NPS$I : null;

            if (!(prefix == null)) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return");

          case 10:
            threshold = question["".concat(prefix, "Score")];

            if (!(threshold == null)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return");

          case 13:
            direction = question["".concat(prefix, "ScoreDirection")] === 'g' ? 1 : -1;
            return _context2.abrupt("return", [0, direction].includes(Math.sign(score - threshold)));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function select(_x2) {
    return _ref2.apply(this, arguments);
  };
}();